<template>
    <section class="col-span-12">
        <article
            v-if="element"
            :class="dinamyc_bg"
            class="cursor-pointer w-full max-h-[96px] laptopXL_1:h-[96px] laptop:h-[70px] tabletDefault:h-[52px] mobileXXL:h-[36px] mobile:h-[24px]"
            @click="openUrl(element)">
            <img :src="element.banner_header" alt="banner_header_desktop" class="h-full max-w-[1440px] mx-auto ">
        </article>
    </section>
</template>
<script setup>
import {computed, onMounted, ref} from 'vue';
import {page} from '@/shared/helpers.js';
import axios from 'axios';

let element = ref(page?.props?.banners ?? null);
let active_banners = ref([]);
let index = ref(0);

onMounted(() => axios.get(route('get_active_banners')).then(response => {
    active_banners.value = response?.data ?? [];

    if (active_banners.value?.length > 1) {
        setInterval(() => {
            let banner_index = index.value;
            if (index.value === active_banners.value.length - 1) {
                index.value = 0;
            } else {
                index.value++;
            }

            element.value = active_banners.value[banner_index];
        }, 10000);
    }
}));

function openUrl(element) {
    window.open(element.url_header, element?.target ?? '_blank').focus();
}

let dinamyc_bg = computed(() => {
    let out = 'bg-[#161924]';
    if (element.value.id === 7) {
        out = 'bg-[#FED12D]';
    }
    if (element.value.id === 6) {
        out = 'bg-gradient-to-r from-gray-900 from-40% to-50% to-[#E4AF2F]';
    }
    if (element.value.id === 9) {
        out = 'bg-[#20202B]';
    }
    if (element.value.id === 10) {
        out = 'bg-white';
    }
    return out;
});
</script>
